<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md class="subnav__reduced-padding">
    <sbnb-back-button style="margin-bottom: 20px"></sbnb-back-button>

    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'gx-custom-code-detail'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs class="block sbnbDesktop:hidden"></sbnb-page-header>
    </app-feature-flag-tabs>
    <div *ngIf="loading" class="table__no-items">Loading custom code details...</div>

    <ng-container *ngIf="!loading && ccData">
      <div fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
        <div fxFlex fxLayoutAlign="start center" fxLayoutGap="8px">
          <h2 fxLayoutAlign="start center" fxLayoutGap="16px" class="nomargin">
            {{ ccData.key }}
          </h2>
        </div>

        <sbnb-cs-debug-item
          label="id"
          [coreNovaLink]="'/resources/custom-codes/' + ccData.id"
          [linkLabel]="'Nova'"
          [value]="ccData.id"></sbnb-cs-debug-item>

        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </div>

      <div class="rule__section-container">
        <div fxLayout fxLayoutAlign="start center">
          <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px" class="not-clickable">
            <sbnb-icon icon="message" class="text-smoke-darker"></sbnb-icon>
            <span>Text</span>
            <span class="card__collapsed-helper-text">
              This text will replace
              <strong>%%{{ ccData.key }}%%</strong>
              automatically in your messages.
            </span>
          </h3>
        </div>

        <div>
          <sbnb-rule-editor
            #ruleEditor
            [ruleSetId]="ccId"
            [simpleMode]="true"
            [simpleInput]="ccData.text"
            (simpleTextChange)="textUpdated($event)"
            [importEnabled]="true"
            [codesEnabled]="true"
            [previewEnabled]="false"></sbnb-rule-editor>
        </div>
      </div>

      <div class="rule__section-container rule__section-collapsed">
        <div fxLayout fxLayoutAlign="start center">
          <h3
            fxLayoutAlign="start center"
            fxLayoutGap="12px"
            style="margin-top: 0; margin-bottom: 0; padding-right: 40px"
            class="not-clickable">
            <sbnb-icon icon="time" class="shrink-0 text-smoke-darker"></sbnb-icon>
            <span>Condition</span>
          </h3>

          <sbnb-custom-code-conditions
            *ngIf="conditionsMeta && ccData"
            [meta]="conditionsMeta"
            [customCode]="ccData"
            (triggerSave)="handleConditionUpdate($event)"></sbnb-custom-code-conditions>
        </div>
      </div>

      <div class="rule__section-container">
        <div fxLayout fxLayoutAlign="start center">
          <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px">
            <sbnb-icon icon="scope" class="text-smoke-darker"></sbnb-icon>
            <span>Scope</span>
            <span class="card__collapsed-helper-text">
              Limit the extent of the custom code to certain platforms, accounts or properties.
            </span>
          </h3>
        </div>

        <div>
          <sbnb-rule-scope [initial]="ccData" (completed)="handleScopeChange($event)"></sbnb-rule-scope>
        </div>
      </div>

      <div class="rule__section-container" fxLayout>
        <div fxFlex fxLayout fxLayoutGap="6px" fxLayoutAlign="start center">
          <sbnb-button label="Delete" icon="delete" type="secondary-danger" (clicked)="deleteCcPrompt()"></sbnb-button>

          <sbnb-button label="Copy" icon="copy" type="secondary" (clicked)="copyCc()"></sbnb-button>
        </div>

        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </div>
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Guest Experience'">
  <sbnb-gx-subnav></sbnb-gx-subnav>
</sbnb-mobile-sidebar>
